export default function addScrollToTop() {
  if (typeof (Storage) === "undefined") {
    return;
  }

  var $backToTop;

  if (typeof (window.localStorage) != "undefined" && window.localStorage.getItem('hideBackToTop') == null) {
    $backToTop = $('#back-top');
    initScrollToTop($backToTop);

    // scroll body to 0 on click
    $backToTop.find('.arrow').on('click', function () {
      if (!$(this).data('clickDenied')) {
        var $that = $(this);
        $that.data('clickDenied', true);

        $('body,html').animate(
          { scrollTop: 0 },
          800,
          'swing',
          function () {
            $that.data('clickDenied', false);
          });
      }

      return false;
    });

    $backToTop.find('.close').on('click', function () {
      window.localStorage.setItem('hideBackToTop', 'true');

      $backToTop.fadeOut('fast', function () {
        $(this).remove();
      });
    });
  }
}

// Returns a function, that, as long as it continues to be invoked, will not
// be triggered. The function will be called after it stops being called for
// N milliseconds. If `immediate` is passed, trigger the function on the
// leading edge, instead of the trailing.
function scrollToTopDebounce(a, b, c) { var d; return function () { var e = this, f = arguments; clearTimeout(d), d = setTimeout(function () { d = null, c || a.apply(e, f) }, b), c && !d && a.apply(e, f) } }

var initScrollToTop = function ($backToTop) {
  window.addEventListener('scroll', scrollToTopDebounce(function () {
    $backToTop = $('#back-top');
    var scrollToTop = $(window).scrollTop();

    if (scrollToTop > 100) {
      $backToTop.fadeIn(100);
    }
    else {
      $backToTop.fadeOut(100);
    }
  }, 250), { passive: true });
}